import React from 'react';

export default function XIcon() {
  return (
    <>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </>
  );
}
